import axios from 'axios';
import { Student, SubjectStudents, Professor } from 'src/models';

import { BASE_URL } from './config';
const ENDPOINT = '/api/pdf';

export function createPdf(
  students: Student[],
  subjectStudents: SubjectStudents,
  plan: string,
  professor: Professor,
  opportunityType: string,
  incorrectGrades: Record<string, string>,
  correctGrades: Record<string, string>,
  reason: string,
  academy: string,
  coordinatorName: string
) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
    responseType: 'blob',
  });

  // Build payload using the backend schema fields:
  // - students
  // - subject_students
  // - plan
  // - professor
  // - opportunity_type
  // - incorrect_grades
  // - correct_grades
  // - reason
  // - academy
  // - coordinator_name
  return apiClient.post(ENDPOINT, {
    students: students,
    subject_students: subjectStudents,
    plan: plan,
    professor: professor,
    opportunity_type: opportunityType,
    incorrect_grades: incorrectGrades,
    correct_grades: correctGrades,
    reason: reason,
    academy: academy,
    coordinator_name: coordinatorName,
  });
}
